import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-header-location-button",
  templateUrl: "./header-location-button.component.html",
  styleUrls: ["./header-location-button.component.scss"],
})
export class HeaderLocationButtonComponent {
  @Input() adressMessage = "";
  @Output() pressed = new EventEmitter<void>();
}
